import React from 'react';
import ListingImageGallery from './ListingImageGallery/ListingImageGallery';

import css from './ListingPage.module.css';

const SectionGallery = props => {
  const { listing, variantPrefix, variantImageId, variantImageIds } = props;
  const images = listing.images || [];
  const imageVariants = ['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge'];
  const thumbnailVariants = [variantPrefix, `${variantPrefix}-2x`, `${variantPrefix}-4x`];

  // Find the gallery index of the selected variant's image so we can slide to it
  const selectedIndex =
    variantImageId != null
      ? images.findIndex(img => img?.id?.uuid === variantImageId)
      : -1;

  return (
    <section className={css.productGallery} data-testid="carousel">
      <ListingImageGallery
        images={images}
        imageVariants={imageVariants}
        thumbnailVariants={thumbnailVariants}
        selectedIndex={selectedIndex >= 0 ? selectedIndex : undefined}
        variantImageIds={variantImageIds}
      />
    </section>
  );
};

export default SectionGallery;
